//引入外部模組
import 'jquery-easing/jquery.easing.1.3';




//Tabs 切換 DIV
class Tabs {
  constructor() {
    this.header   = $('header');
    this.tabs     = $('.tabBtns');
    this.btns     = this.tabs.find('a, button');
    this.duration = 500;
    this.easing   = 'easeOutExpo';
    this.showTab  = 0;
  }
  //錨點跳躍
  linkScrollTo() {
    this.btns.each((i, e) => {
      $(e).on('click', (event) => {
        event.preventDefault();
        let position = 0;
        if(i === 5){
          position = $('#actualData').offset().top - this.header.outerHeight();
        }else{
          position = this.tabs.offset().top - this.header.outerHeight() - 20;
        }
        $('html, body').animate({
          scrollTop: position
        }, this.duration, this.easing);
      });
    });
  }
  tabsToggle() {
    //錨點跳躍
    this.linkScrollTo();

    this.btns.each((i, e) => {
      if(i !== 5){
        let $default = this.btns.eq(this.showTab).addClass('active');
        $($default.attr('href')).addClass('active');
        $($default.attr('href')).siblings().removeClass('active');

        $(e).on('click', () => {
          let $clickTab = $(e).attr('href');
          this.btns.removeClass('active');
          $(e).addClass('active');
          $($clickTab).stop(false, true).addClass('active').siblings().removeClass('active');

          //環景看屋ajax
          /*
          if(i == 3) {
            //內容另外加入
            // $('#tab4').html('123');
            console.log('start');
            
            let obj_sn = $(e).attr('obj_sn');
            let obj_id = $(e).attr('obj_id');
            let nav = $(e).attr('nav');
            let obj_vr720 = $(e).attr('obj_vr720');
            let vr720Tabs = $(e).attr('vr720Tabs');
            // console.log(vr720Tabs);
            $.ajax('ajax_realty_720.php', { data: { obj_sn: obj_sn, obj_id:obj_id, nav: nav, obj_vr720: obj_vr720, vr720Tabs: vr720Tabs },
                type: "post",
                success: function(data) {
                  console.log('111');
                  $('#tab4').html(data);
                }
              }
            ); //$.ajax(
              
            

          } //if(i == 3) {
            */

          //物件地圖ajax 
          
          if(i == 4) {

            let obj_id = $(e).attr('obj_id');

            //內容另外加入
            // alert('5');
            // $('#tab5').html(obj_id);
            
            // $.ajax('index.php?nav=ajax_realty_map&id=57862', { data: { id: obj_id },
            $.ajax('index.php?nav=ajax_realty_map', { 
                data: { 'id': obj_id },
                type: "get",
                success: function(data) {
                  
                  $('#tab5').html(data);

                  // const iframeWindow = document.getElementsByTagName('iframe')[0].contentWindow;
                  // iframeWindow.document.body.innerHTML = data;
                } //success: function(data) {
              }
            ); //$.ajax(
              
          } //if(i == 4) {


          return false;
        }).focus(() => {
          $(e).blur();
        });
      }
    });
  }
}




//Toggle Slide
class ToggleSlide {
  constructor() {
    this.slide    = $('.slideBox');
    this.slideBtn = $('.slideBtn');
  }
  toggleSlide() {
    this.slideBtn.on('click', (e) => {
      const $this = $(e.currentTarget);
      this.slide.addClass('active');
      $this.remove();
    });
  }
}




//輸出

export {Tabs, ToggleSlide};


// WEBPACK FOOTER //
// ./js_new/tabs.js